/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";
import { CART_LINE_TYPES } from "../../constants/constants";

const PATH_BY_TYPE = {
  [CART_LINE_TYPES.PRODUCT]: "add-product",
  [CART_LINE_TYPES.MEMBERSHIP]: "add-membership",
  [CART_LINE_TYPES.PACKAGE]: "add-package",
  [CART_LINE_TYPES.PROMOTION]: "add-promotion",
};

export const useInvoiceAddLine = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.invoiceAddLine,
    mutationFn: ({ type, invoiceId, ...data }) => {
      const path = PATH_BY_TYPE[type];
      if (!path) throw new Error(`Unsupported cart line type: ${type}`);

      return fetcher({ method: "POST", url: `/public/invoice/${path}/id/${invoiceId}`, data });
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invoices.all });

      if (variables?.invoiceId) {
        queryClient.invalidateQueries({ queryKey: queryKeys.invoice.detail(variables.invoiceId) });
      }
    },
  });
};
